import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  onConfirm: () => Promise<void>
  onClose: () => void
}

export const ApproveApplicationDialog = ({ onConfirm, onClose }: Props) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const confirmText = t(
    'kyrgyzstan_block.my_objects.applications.approve_dialog.confirm',
  )

  const handleConfirm = async () => {
    if (isLoading) {
      return
    }

    setIsLoading(true)

    try {
      await onConfirm()
    } catch {
      setIsLoading(false)
    }
  }

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx('bold-20', s.title)}>
          {t('kyrgyzstan_block.my_objects.applications.approve_dialog.title')}
        </p>
        <p className={clsx('regular-14', s.description)}>
          {t(
            'kyrgyzstan_block.my_objects.applications.approve_dialog.description',
          )}
        </p>
      </div>

      <div className={s.buttons}>
        <button
          type="button"
          className={clsx('semi-bold-17', s.button, s.confirmButton)}
          onClick={handleConfirm}
          disabled={isLoading}
          aria-busy={isLoading}
          aria-label={confirmText}
        >
          {isLoading ? (
            <span
              className={s.buttonLoader}
              aria-hidden="true"
            />
          ) : (
            confirmText
          )}
        </button>

        <button
          type="button"
          className={clsx('bold-17', s.button, s.closeButton)}
          onClick={onClose}
        >
          {t('kyrgyzstan_block.my_objects.applications.approve_dialog.close')}
        </button>
      </div>
    </div>
  )
}
